import React from 'react';
import styled from 'styled-components';
import { media } from '@/styles/theme';
import type { MessageProps } from '@/types';

interface StyledMessageProps {
  $large?: boolean;
  $vertical?: boolean;
  $color?: string;
}

const StyledMessage = styled.p<StyledMessageProps>`
  margin: 0;
  font-size: 14px;
  margin-bottom: 12px;
  width: 266px;
  text-align: center;
  opacity: 0.75;

  ${media.mobileLandscape} {
    width: 260px;
  }

  ${media.tablet} {
    font-size: 20px;
    text-align: right;
    padding-right: 34px;
    margin-right: 24px;
    margin-bottom: 0;
    border-color: ${({ theme }) => theme.colors.border};
    border-right: 4px solid ${({ theme }) => theme.colors.border};
  }

  ${({ $large }) =>
    $large &&
    `
    font-size: 20px;
    margin-bottom: 36px;
    width: 200px;
    
    ${media.tablet} {
      font-size: 28px;
      margin-bottom: 0;
      width: 220px;
    }
  `}

  ${({ $vertical }) =>
    $vertical &&
    `
    margin: 0;
    font-size: 14px;
    margin-bottom: 12px;
    text-align: center;
    opacity: 0.75;
    width: auto;
    
    ${media.tablet} {
      text-align: center;
      padding-right: 0;
      margin-right: 0;
      border-right: none;
    }
  `}
`;

const Message: React.FC<MessageProps> = ({
  color,
  large,
  vertical,
  children,
}) => {
  return (
    <StyledMessage $large={large} $vertical={vertical} $color={color}>
      {children}
    </StyledMessage>
  );
};

export default Message;
